import { createRemoteConfigAtomFactory } from '@exodus/remote-config-atoms';
const createAssetServersConfigAtom = ({ remoteConfig }) => createRemoteConfigAtomFactory({ remoteConfig })({
    path: 'assets',
    defaultValue: {},
});
const assetServersConfigAtomDefinition = {
    id: 'assetServersConfigAtom',
    type: 'atom',
    factory: createAssetServersConfigAtom,
    dependencies: ['remoteConfig'],
};
export default assetServersConfigAtomDefinition;
